import PrenotazioniPage from "./pages/PrenotazioniPage.vue";

export default {
	PrenotazioniPage,
};
